/*
 * SPDX-FileCopyrightText: 2023 SEIVA Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const asm = {
  asm: {
    customerSearch: {
      submit: 'Iniciar sessão',
    },
    bindCart: {
      cartNumber: 'Número do Carrinho',
      bindCartToCustomer: 'Atribuir carrinho ao cliente'
    },
    startCustomerEmulationAlertInfo: 'A emulação do cliente foi iniciada. Quaisquer ações que você realizar refletirão os efeitos na conta do cliente.',
    asmCustomer360Button: "Vista do Cliente 360°",
    mainLogoLabel: 'SEIVA',
    mainTitle: 'Modo de Serviço Assistido',
    logout: 'Fazer logoff',
    hideUi: 'Fechar ASM',
    helpPortalUrl: 'Ajuda',
    customers: 'Clientela',
    createClienteSuccessfullyAlert:
      'A conta do cliente foi criada e a sessão do cliente foi iniciada.',
    saveInactiveCarroAlertInfo:
      'O carrinho identificado é um carrinho ocioso. Para executar outras ações neste carrinho, salve-o primeiro.',
    activeCarroAlertInfo: 'O carro identificado é um carro ativo.',
    startClienteEmulationAlertInfo:
      'A emulação do cliente começou. Qualquer ação que você tomar refletirá os efeitos na conta do cliente.',
    toggleUi: {
      collapse: 'Ocultar ASM',
      expand: 'Mostrar ASM',
    },
    loginForm: {
      submit: 'Iniciar sessão',
      userId: {
        label: 'ID do agente',
        required: 'ID do agente necessário',
      },
      password: {
        label: 'Senha',
        required: 'Senha necessária',
      },
    },
    customerAchar: {
      searchTerm: {
        label: 'Número do cliente/Endereço eletrônico',
      },
      submit: 'Entrar',
      startEmulation: 'Iniciar emulação',
      noMatch: 'Nenhum cliente encontrado.',
      noMatchResult: 'Esta conta não pode ser encontrada.',
      createCliente: 'Criar novo cliente',
    },
    createClienteForm: {
      title: 'Criar novo cliente',
      createConta: 'Criar',
      cancel: 'Cancelar',
      firstNúmero: {
        label: 'Nome',
        placeholder: 'Nome',
      },
      lastNúmero: {
        label: 'Sobrenome',
        placeholder: 'Sobrenome',
      },
      emailAddress: {
        label: 'Endereço eletrônico',
        placeholder: 'Endereço eletrônico',
      },
      createContaAlert:
        'A sessão do cliente começa assim que você cria a conta do cliente.',
      validationErrors: {
        firstNúmero: 'Insira um nome válido.',
        lastNúmero: 'Insira um sobrenome válido.',
        emailAddress: 'Insira um endereço de e-mail válido.',
      },
      badRequestDuplicatedEmail:
        'Insira um endereço de e-mail diferente, pois {{  emailAddress }} já existe.',
    },
    customerList: {
      oneCustomer: '1 Cliente',
      noOfCustomers: '{{count}} Clientes',
      title: 'Lista de clientes',
      description: 'Selecione um cliente em uma das várias listas fornecidas.',
      createCliente: 'Criar novo cliente',
      cancel: 'Cancelar',
      tableHeader: {
        customer: 'Cliente',
        customerName: 'Número do cliente',
        name: 'Nome',
        email: 'Email',
        emailId: 'Email/IDENTIFICAÇÃO',
        b2bUnitName: 'Número do cliente',
        b2bUnitCode: 'Cliente',
        cif: 'CIF',
        poblacion: 'População',
        phone: 'Telefone',
        account: 'Conta',
        cart: 'Carro',
        order: 'Ordem',
        view: 'Visualizações 360',
      },
      tableSort: {
        sortBy: 'Ordemar por',
        byNúmero: 'Número (Asc)',
        byNúmeroAsc: 'Número (Asc)',
        byNúmeroDesc: 'Número (Desc)',
        byDateAsc: 'Data (Asc)',
        byDateDesc: 'Data (Desc)',
        byOrdemDateAsc: 'Ordem de fecha (Asc)',
        byOrdemDateDesc: 'Ordem de fecha (Desc)',
        byUnit: 'Conta (Asc)',
        byUnitDesc: 'Conta (Desc)',
      },
      page: {
        page: 'Página {{count}}',
        previous: 'Anterior',
        next: 'Próximo',
      },
      noOfClientela: '{{count}} Clientes',
      oneCliente: '1 Cliente',
      noClientela: 'No momento, não há clientes nesta lista de clientes.',
      noLists:
        'No momento, não há listas de clientes disponíveis. Entre em contato com o adMinistrador do sistema.',
      listsError:
        'Não foi possível recuperar as listas de clientes. Por favor, tente novamente mais tarde.',
      searchBox: 'Achar',
      enterAcharBox: 'Insira o nome ou e-mail do cliente',
    },
    switchCliente: {
      dialog: {
        title: 'Aviso',
        body: 'Clicking "Switch de cliente" will end the emulation for "{{ customerA }}" and start for "{{ customerB }}". Any unsaved changes for "{{ customerA }}" will be lost.',
        actions: {
          switch: 'Switch de cliente',
        },
      },
    },
    saveCarro: {
      saveCarroBtn: 'Guardar para mais tarde',
      dialog: {
        saveInfo: 'Salve o carrinho antes de executar qualquer outra ação.',
        disableInfo: 'O carrinho não pode ser armazenado porque está vazio.',
        title: 'Guardar Carro',
        row: {
          id: 'IDENTIFICAÇÃO',
          qty: 'Quantidade',
          total: 'Total',
        },
        actions: {
          save: 'Guardar para mais tarde',
        },
      },
    },
    bindCarro: {
      cartNumber: 'Número de Carro',
      bindCarroToCliente: 'Atribuir carro ao cliente',
      success: 'O carrinho foi atribuído com sucesso',
      assignCarroId: 'Atribuir um carrinho ID ao cliente',
      enterCarroId: 'Digite o ID do carrinho',
      resetCarroId: 'Repor',
      dialog: {
        title: 'Atribuir carrinho anônimo',
        body: 'Deseja substituir o carrinho ativo atual pelo carrinho anônimo? Se você substituir o carrinho ativo atual, ele será salvo como um carrinho salvo.',
        actions: {
          replace: 'Reconduzido ao cargo de Carro',
        },
      },
    },
    csagentTokenExpired: 'A sessão do agente de suporte ao cliente expirou.',
    endSession: 'Fim da sessão',
    endEmulation: 'Emulação final',
    agentSessionTimer: {
      label: 'Tempo limite da sessão',
      Minutes: 'Min',
      reset: 'Repor',
    },
    auth: {
      agentLoggedInError:
        'Você não pode fazer login como usuário quando há uma sessão ativa do agente CS. Emule o usuário ou faça logout do agente CS.',
    },
    error: {
      noClienteId:
        'Nenhum customerId foi encontrado para o usuário selecionado. Não é possível fazer login.',
    },
  },
};
